// PostHog Helper - sicheres Tracking
function trackCartEvent(eventName, properties = {}) {
  if (typeof posthog !== 'undefined') {
    posthog.capture(eventName, {
      ...properties,
      timestamp: new Date().toISOString(),
      page_url: window.location.href
    });
  }
}

class CartDrawerController {
  constructor() {
    this.baseUrl = window.Shopify.routes.root;

    this.boxData = {};
    this.cartItems = {};
    this.cartData = {};

    this.hasLoadedBoxData = false;
    this.loaderEl = $('.custom-drawer__loader-container');
  }

  async init() {
    await this._fetchBoxData();

    this._registerElements();
    this._bindHandlers();
    this._hideLoader();
  }

  openCart(e) {
    if (e?.preventDefault && e?.stopPropagation) {
      e.preventDefault();
      e.stopPropagation();
    }

    $('.custom-drawer-container').addClass('active');
    $('html').addClass('disabled-scroll');

    window.addEventListener("wheel", this.preventScroll.bind(this));
    window.addEventListener("touchmove", this.preventScroll.bind(this));

    // Track cart opened
    const boxItems = JSON.parse(localStorage.getItem('boxItemsInCart')) || [];
    trackCartEvent('cart_opened', {
      box_items_count: boxItems.length,
      total_items: this.cartData?.items?.length || 0,
      total_price: this.cartData?.total_price || 0
    });
  }

  closeCart() {
    $('.custom-drawer-container').removeClass('active');
    $('html').removeClass('disabled-scroll');

    window.removeEventListener("wheel", this.preventScroll.bind(this));
    window.removeEventListener("touchmove", this.preventScroll.bind(this));
  }

  preventScroll(e) {
    if (!this.isDescendant($('.custom-drawer-container'), e.target)) {
      e.preventDefault();
      return false;
    }

    let modalTop = modalEl.scrollTop === 0;
    let modalBottom = modalEl.scrollTop === (modalEl.scrollHeight - modalEl.clientHeight);

    if (modalTop && e.deltaY < 0) {
      e.preventDefault();
    } else if (modalBottom && e.deltaY > 0) {
      e.preventDefault();
    }
  }

  isDescendant(parent, child) {
    var node = child.parentNode;
    while (node != null) {
      if (node == parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  }

  async updateCart() {
    await this._populateCartItems();

    this._emptyCart();
    this._generateCheckoutLink();
    this._generateRegularItems();
    this._generateBoxCartItems();
    this._generateClearCartButton();

    if (this.cartData.items.length > 0) {
      this.checkoutButtonEl.show();
      this.disabledCheckoutButtonEl.hide();
    } else {
      this.checkoutButtonEl.hide();
      this.disabledCheckoutButtonEl.show();
    }

    this._checkIfCartIsEmpty(this.cartData.items.length, this.cartData);
  }

  async _checkIfCartIsEmpty(item_count, cartData) {
        let prebuiltList = document.querySelector(".custom-drawer__prebuilt-list");
        let postbuiltList = document.querySelector(".custom-drawer__build-a-box-products");
      
        let hasPrebuiltItems = prebuiltList?.querySelector(".custom-drawer__prebuilt-item");
        let hasPostbuiltItems = postbuiltList?.querySelector(".custom-drawer__box-list-item");
        console.log(cartData?.items_subtotal_price);
        if(cartData?.items_subtotal_price <= 0 && !hasPrebuiltItems && !hasPostbuiltItems){
          await fetch('/cart/clear.js')
          .then(res => res.json())
          .then(cart => console.log(cart, 'Cart Cleared'));
          document.cookie = `cart=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          console.log('cookie cleared');
          await this._populateCartItems();

          this._emptyCart();
          this._generateCheckoutLink();
          this._generateRegularItems();
          this._generateBoxCartItems();
      
          if (this.cartData.items.length > 0) {
            this.checkoutButtonEl.show();
            this.disabledCheckoutButtonEl.hide();
          } else {
            this.checkoutButtonEl.hide();
            this.disabledCheckoutButtonEl.show();
          }
        }
  }
  
  _bindHandlers() {
    const that = this;

    this.cartBubbleEl.click(function (e) {
      that.openCart(e);
      that.updateCart();
    });

    this.cartCloseButtonEl.click(() => {
      that.closeCart();
    });
  }

  _showLoader() {
    this.loaderEl.show();
  }

  _hideLoader() {
    this.loaderEl.hide();
  }

  _registerElements() {
    this.productsContainerEl = $('.custom-drawer__build-a-box-products');
    this.cartItemCountEl = $('.cart-item-count-value');
    this.totalPriceEl = $(`.custom-drawer__total-price`);
    this.shippingPriceEl = $('.custom-drawer__shipping-value');
    this.cartBubbleEl = $('#cart-icon-bubble');
    this.checkoutButtonEl = $('.custom-drawer__checkout-button');
    this.disabledCheckoutButtonEl = $('.custom-drawer__disabled-checkout-button');
    this.prebuiltProductListEl = $('.custom-drawer__prebuilt-list');
    this.buildABoxListEl = $('.custom-drawer__build-a-box-products');
    this.cartCloseButtonEl = $('.custom-drawer__header button');
  }

  _generateCheckoutLink(note) {
    const itemsParam = this.cartItems.allItems.map(item => `${item.id}:${item.quantity}`).join(',');

    const that = this;

    // Entferne alte Click-Handler um Duplikate zu vermeiden
    this.checkoutButtonEl.off('click');

    this.checkoutButtonEl.click(async function () {
      // Checkout-Button waehrend Validierung deaktivieren
      const $btn = $(this);
      $btn.prop('disabled', true);

      try {
        // === LIVE CART VALIDIERUNG (gegen echten Shopify Cart) ===
        const liveCart = await that._fetchShopifyCartContents();
        const liveItems = liveCart.items;

        const liveMealItems = liveItems.filter(i => i.product_type === 'meal');
        const liveBoxItems = liveItems.filter(i => i.product_type === 'box' || i.product_type === 'build-a-box');

        const totalMealsInCart = liveMealItems.reduce((sum, i) => sum + i.quantity, 0);
        const totalExpectedMeals = liveBoxItems.reduce((sum, box) => {
          let perBox = 0;
          // Bevorzuge _expected_meal_count Property (funktioniert fuer alle Box-Typen)
          if (box.properties && box.properties._expected_meal_count) {
            perBox = Number(box.properties._expected_meal_count);
          } else if (box.handle.includes('18er')) perBox = 18;
          else if (box.handle.includes('12er')) perBox = 12;
          else if (box.handle.includes('6er')) perBox = 6;
          return sum + (perBox * box.quantity);
        }, 0);

        if (totalMealsInCart !== totalExpectedMeals) {
          console.error('SECURITY: Meal count mismatch at checkout', { expected: totalExpectedMeals, actual: totalMealsInCart });

          trackCartEvent('checkout_blocked_meal_count_mismatch', {
            expected_meals: totalExpectedMeals,
            actual_meals: totalMealsInCart,
            boxes: liveBoxItems.map(b => ({ handle: b.handle, qty: b.quantity })),
            meals: liveMealItems.map(m => ({ handle: m.handle, qty: m.quantity }))
          });

          alert('Es gibt ein Problem mit der Anzahl der Meals in deinem Warenkorb. Bitte entferne die Box und füge sie erneut hinzu.');
          $btn.prop('disabled', false);
          return;
        }

        // === SEKUNDAERE VALIDIERUNG: localStorage-Check ===
        const boxItems = JSON.parse(localStorage.getItem('boxItemsInCart')) || [];

        const invalidBoxes = boxItems.filter(box => {
          if (!box.boxItems || box.boxItems.length === 0) {
            return true;
          }

          // Bestimme erwartete Meals: zuerst aus bekannten Handles, dann aus Live-Cart-Property
          let expectedMeals = 0;
          if (box.handle === '6er-meal-box') expectedMeals = 6;
          else if (box.handle === '12er-meal-box') expectedMeals = 12;
          else if (box.handle === '18er-meal-box') expectedMeals = 18;
          else {
            // Fuer non-standard Box-Handles: Suche _expected_meal_count im Live-Cart
            const matchingLiveBox = liveBoxItems.find(lb =>
              lb.properties && lb.properties._box_instance_id === box.boxInstanceId
            );
            if (matchingLiveBox && matchingLiveBox.properties._expected_meal_count) {
              expectedMeals = Number(matchingLiveBox.properties._expected_meal_count);
            }
          }

          const actualMeals = box.boxItems.reduce((sum, meal) => sum + (meal.quantity || 0), 0);

          if (expectedMeals > 0 && actualMeals !== expectedMeals) {
            return true;
          }

          return false;
        });

        if (invalidBoxes.length > 0) {
          console.error('SECURITY: Invalid boxes detected at checkout', invalidBoxes);

          trackCartEvent('checkout_blocked_invalid_boxes', {
            invalid_boxes: invalidBoxes.map(b => ({
              handle: b.handle,
              meals_count: b.boxItems?.length || 0,
              total_quantity: b.boxItems?.reduce((s, m) => s + (m.quantity || 0), 0) || 0
            })),
            total_boxes: boxItems.length
          });

          alert('Es gibt ein Problem mit einer Box in Ihrem Warenkorb. Bitte entfernen Sie diese und fügen Sie sie erneut hinzu.');
          $btn.prop('disabled', false);
          return;
        }

        // Track checkout started
        trackCartEvent('checkout_started', {
          total_boxes: boxItems.length,
          total_items: that.cartItems?.allItems?.length || 0,
          total_price: that.cartData?.total_price || 0,
          live_validation: { expected_meals: totalExpectedMeals, actual_meals: totalMealsInCart },
          box_breakdown: boxItems.map(b => ({
            handle: b.handle,
            quantity: b.quantity,
            meals_count: b.boxItems?.length || 0
          }))
        });

        let latestNotes = document.querySelector('cart-note textarea#CartDrawer-Note').value
        latestNotes = latestNotes ? latestNotes : '';
        window.location.href = `${that.baseUrl}cart/${itemsParam}?note=${latestNotes}`;
      } catch (error) {
        console.error('Checkout validation error:', error);
        trackCartEvent('checkout_validation_error', { error: error.message || 'Unknown' });
        // Bei Fehler trotzdem erlauben (bestehende localStorage-Validierung greift)
        $btn.prop('disabled', false);
        alert('Es gab einen Fehler bei der Validierung. Bitte versuche es erneut.');
      }
    });
  }

  _populateCartItems() {
    const that = this;

    return new Promise((resolve) => {
      const regularItems = [];
      const mealItems = [];
      const orphanedBoxItems = [];

      const rawBoxItems = localStorage.getItem('boxItemsInCart');
      const boxItems = JSON.parse(rawBoxItems);

      console.log('[DEBUG _populateCartItems] localStorage boxItemsInCart raw:', rawBoxItems);
      console.log('[DEBUG _populateCartItems] localStorage boxItemsInCart parsed:', JSON.stringify(boxItems, null, 2));

      $.ajax({
        type: 'GET',
        url: '/cart.js',
        success: (res) => {
          this.cartData = JSON.parse(res);
          const { items, total_price } = this.cartData;

          console.log('[DEBUG _populateCartItems] Shopify cart items count:', items.length);
          items.forEach((item, idx) => {
            console.log(`[DEBUG _populateCartItems] Cart item [${idx}]: id=${item.id} (type: ${typeof item.id}), key="${item.key}", product_type="${item.product_type}", handle="${item.handle}", qty=${item.quantity}, properties=`, item.properties);
          });

          const newBoxItems = [];
          const claimedCartKeys = new Set();

          if (boxItems) {
            console.log('[DEBUG _populateCartItems] localStorage has', boxItems.length, 'box entries');
            boxItems.forEach((boxItem, idx) => {
              console.log(`[DEBUG _populateCartItems] localStorage box [${idx}]: id=${boxItem.id}, key="${boxItem.key}", handle="${boxItem.handle}", boxInstanceId="${boxItem.boxInstanceId}"`);

              // Match nur gegen Box-Items (product_type check), da Meals auch _box_instance_id haben
              const isBoxType = (item) => item.product_type === 'box' || item.product_type === 'build-a-box';
              const cartBoxItem = items.find(item =>
                !claimedCartKeys.has(item.key) && isBoxType(item) && (
                  (boxItem.boxInstanceId && item.properties && item.properties._box_instance_id === boxItem.boxInstanceId) ||
                  (boxItem.key && item.key === boxItem.key) ||
                  (item.id == boxItem.id)
                )
              );

              if (cartBoxItem) {
                console.log(`[DEBUG _populateCartItems] MATCHED localStorage box [${idx}] -> cart key="${cartBoxItem.key}" (instance: ${cartBoxItem.properties?._box_instance_id})`);
                claimedCartKeys.add(cartBoxItem.key);
                boxItem.key = cartBoxItem.key;
                // Preisdaten aus dem Shopify Cart uebernehmen (fuer non-standard Box-Handles)
                boxItem.cartPrice = cartBoxItem.price;
                boxItem.cartCompareAtPrice = cartBoxItem.compare_at_price;
                newBoxItems.push(boxItem);
              } else {
                console.log(`[DEBUG _populateCartItems] NO MATCH for localStorage box [${idx}] - will be removed from localStorage`);
              }
            });

            localStorage.setItem('boxItemsInCart', JSON.stringify(newBoxItems));
          } else {
            console.log('[DEBUG _populateCartItems] localStorage boxItemsInCart is null/empty');
          }

          console.log('[DEBUG _populateCartItems] claimedCartKeys:', Array.from(claimedCartKeys));

          that._updateCartTotalPrice(total_price);
          that._updateShippingPrice(total_price);

          items.forEach(item => {
            if (item.product_type === 'box' || item.product_type === 'build-a-box') {
              const isClaimed = claimedCartKeys.has(item.key);
              console.log(`[DEBUG _populateCartItems] Box in cart: key="${item.key}", claimed=${isClaimed}`);
              if (!isClaimed) {
                console.log(`[DEBUG _populateCartItems] -> ORPHANED box: key="${item.key}", handle="${item.handle}"`);
                orphanedBoxItems.push(item);
              }
            } else if (item.product_type === 'meal') {
              mealItems.push(item);
            } else {
              regularItems.push(item);
            }
          });

          console.log('[DEBUG _populateCartItems] RESULT: newBoxItems:', newBoxItems.length, 'orphanedBoxItems:', orphanedBoxItems.length, 'regularItems:', regularItems.length, 'mealItems:', mealItems.length);

          that.cartItems.regularItems = regularItems;
          that.cartItems.boxItems = newBoxItems;
          that.cartItems.orphanedBoxItems = orphanedBoxItems;
          that.cartItems.mealItems = mealItems;
          that.cartItems.allItems = newBoxItems.concat(regularItems).concat(mealItems).concat(orphanedBoxItems);

          that._updateCartItemCount(this.cartItems.regularItems.length + this.cartItems.boxItems.length + orphanedBoxItems.length);

          resolve(true);
        }
      });
    });
  }

  _updateCartTotalPrice(price) {
    const formattedPrice = (price / 100).toFixed(2);
    $(`.custom-drawer__total-price`).text(`${formattedPrice}€`);

    // Versandkosten (4,99 €) unterhalb der Gratis-Versand-Grenze aufschlagen.
    // Gleiche Schwelle wie _updateShippingPrice, sonst weichen Button und Versand-Zeile voneinander ab.
    if ((price / 100) < parseInt(window.shippingRate)) {
      const totalPrice = ((price + 499) / 100).toFixed(2);

      $('#custom-drawer__checkout-button-total').text(`${totalPrice}€`);
    } else {
      $('#custom-drawer__checkout-button-total').text(`${formattedPrice}€`);
    }
  }

  _updateCartItemCount(count) {
    $('.cart-item-count-value').text(count);
    $('.custom-drawer__header span').text(`${count} Produkte`);
  }

  async _generateRegularItems() {
    this.prebuiltProductListEl.empty();

    this.cartItems.regularItems.forEach(item => {
      const { handle } = item;

      $.getJSON(`/products/${handle}.js`, (product) => {
        const { compare_at_price, price } = product;

        const hasDiscount = compare_at_price && price !== compare_at_price;

        const formattedDiscountPrice = (price * item.quantity / 100).toFixed(2);
        const formattedRegularPrice = (compare_at_price * item.quantity / 100).toFixed(2);

        const itemElement = `
          <div class="custom-drawer__prebuilt-item">
            <img src="${item.image}"/>

            <div class="custom-drawer__prebuilt-item-content">
              <h1>${item.quantity > 1 ? item.quantity + ' x ' : ''}${product.title}</h1>

              <div class="custom-drawer__prebuilt-item-pricing">
                ${hasDiscount ? `<b class="custom-drawer__prebuilt-item-discounted-price">${formattedDiscountPrice}€</b>` : ''}
                <span class="custom-drawer__prebuilt-item-price">${formattedRegularPrice}€</span>
              </div>

              <p class="custom-drawer__remove-regular-item" data-key="${item.key}">Entfernen</p>
            </div>
          </div>
        `;

        this.prebuiltProductListEl.append(itemElement);

        const that = this;

        $(`.custom-drawer__remove-regular-item[data-key="${item.key}"]`).click(function () {
          that._removeRegularItem(item.key);
        });
      });
    });

    // Orphaned Boxen rendern (im Shopify Cart aber nicht in localStorage)
    this._generateOrphanedBoxItems();
  }

  async _generateOrphanedBoxItems() {
    if (!this.cartItems.orphanedBoxItems || this.cartItems.orphanedBoxItems.length === 0) return;

    this.cartItems.orphanedBoxItems.forEach((item, index) => {
      const formattedPrice = (item.price * item.quantity / 100).toFixed(2);

      // Versuche Meals aus dem Shopify Cart per _box_instance_id zu finden
      const boxInstanceId = item.properties?._box_instance_id;
      let associatedMeals = [];
      if (boxInstanceId && this.cartItems.mealItems) {
        associatedMeals = this.cartItems.mealItems.filter(meal =>
          meal.properties && meal.properties._box_instance_id === boxInstanceId
        );
      }

      // Wenn Meals vorhanden: selbes Layout wie normale Boxen (_generateBoxCartItems)
      if (associatedMeals.length > 0) {
        const listItem = `
          <div class="custom-drawer__box-list-item">
            <div class="custom-drawer__box-item-header">
              <div class="custom-drawer__box-item-image">
                <img src="${item.image}" />
              </div>

              <div class="custom-drawer__box-item-header-content">
                <h1>${item.quantity > 1 ? item.quantity + ' x ' : ''}${item.title}</h1>

                <div class="custom-drawer__box-price">
                  <b class="custom-drawer__box-regular-price active">${formattedPrice}€</b>
                </div>

                <p class="custom-drawer__remove-orphaned-box" data-key="${item.key}" data-orphan-index="${index}">Entfernen</p>
              </div>
            </div>

            <div class="custom-drawer__box-item-ingredients">
              <h2>Inhalt</h2>

              <ul>
                ${associatedMeals.map(meal => `
                  <li class="custom-drawer__ingredient">
                    <div class="custom-drawer__ingredient-content">
                      <p><span>${meal.quantity}X</span> ${meal.title}</p>
                    </div>
                  </li>
                `).join('')}
              </ul>
            </div>
          </div>
        `;

        this.buildABoxListEl.append(listItem);

        const that = this;
        $(`.custom-drawer__remove-orphaned-box[data-key="${item.key}"][data-orphan-index="${index}"]`).click(function () {
          that._removeOrphanedBoxWithMeals(item);
        });
      } else {
        // Keine Meals gefunden: einfache Darstellung ohne Inhalt
        const itemElement = `
          <div class="custom-drawer__prebuilt-item custom-drawer__orphaned-box">
            <img src="${item.image}"/>

            <div class="custom-drawer__prebuilt-item-content">
              <h1>${item.quantity > 1 ? item.quantity + ' x ' : ''}${item.title}</h1>

              <div class="custom-drawer__prebuilt-item-pricing">
                <span class="custom-drawer__prebuilt-item-price">${formattedPrice}€</span>
              </div>

              <p class="custom-drawer__remove-regular-item" data-key="${item.key}">Entfernen</p>
            </div>
          </div>
        `;

        this.prebuiltProductListEl.append(itemElement);

        const that = this;
        $(`.custom-drawer__remove-regular-item[data-key="${item.key}"]`).click(function () {
          that._removeOrphanedBoxWithMeals(item);
        });
      }
    });
  }

  async _removeRegularItem(key) {
    this._showLoader();
    await this._updateShopifyCart({ [key]: 0 });
    await this.updateCart();
    this._hideLoader();
  }

  async _removeOrphanedBoxWithMeals(boxItem) {
    this._showLoader();

    try {
      const cart = await this._fetchShopifyCartContents();
      const updates = {};

      // Box auf 0 setzen
      updates[boxItem.key] = 0;

      // Nur Meals dieser Box entfernen (per _box_instance_id)
      const boxInstanceId = boxItem.properties?._box_instance_id;
      if (boxInstanceId) {
        cart.items.forEach(item => {
          if (item.product_type === 'meal' && item.properties && item.properties._box_instance_id === boxInstanceId) {
            updates[item.key] = 0;
          }
        });
      } else {
        // Fallback: Alle Meals entfernen wenn keine Instance-ID vorhanden
        cart.items.forEach(item => {
          if (item.product_type === 'meal') {
            updates[item.key] = 0;
          }
        });
      }

      trackCartEvent('orphaned_box_removed', {
        box_handle: boxItem.handle,
        box_quantity: boxItem.quantity,
        box_instance_id: boxInstanceId || 'none',
        meals_removed: Object.keys(updates).length - 1
      });

      await this._updateShopifyCart(updates);
      await this.updateCart();
    } catch (error) {
      console.error('Error removing orphaned box:', error);
      alert('Fehler beim Entfernen. Bitte versuche "Warenkorb leeren".');
    }

    this._hideLoader();
  }

  async _removeBoxItem(boxData) {
    this._showLoader();

    const boxInstanceId = boxData.boxInstanceId;
    const boxKey = boxData.key;

    // Track box removed from cart
    trackCartEvent('box_removed_from_cart', {
      box_handle: boxData.boxHandle,
      box_quantity: boxData.quantity,
      box_key: boxKey,
      box_instance_id: boxInstanceId
    });

    // 1. localStorage: Entferne nur die spezifische Box (per boxInstanceId oder key)
    const currentBoxItems = JSON.parse(localStorage.getItem('boxItemsInCart')) || [];
    const newBoxItems = currentBoxItems.filter(item => {
      if (boxInstanceId && item.boxInstanceId) {
        return item.boxInstanceId !== boxInstanceId;
      }
      return item.key !== boxKey;
    });
    localStorage.setItem('boxItemsInCart', JSON.stringify(newBoxItems));

    // 2. Shopify Cart: Entferne Box und zugehörige Meals per _box_instance_id
    const cartItems = await this._fetchShopifyCartContents();
    const updates = {};

    // Box selbst entfernen (per key)
    updates[boxKey] = 0;

    // Meals entfernen die zu dieser Box gehören (per _box_instance_id property)
    if (boxInstanceId) {
      cartItems.items.forEach(item => {
        if (item.product_type === 'meal' && item.properties && item.properties._box_instance_id === boxInstanceId) {
          updates[item.key] = 0;
        }
      });
    } else {
      // Fallback: Meals per variant ID und Menge entfernen (alter Mechanismus)
      const mealItems = boxData.items ? boxData.items.split(',') : [];
      const itemsToRemove = {};
      mealItems.forEach(entry => {
        const [id, quantity] = entry.split(':');
        itemsToRemove[id] = Number(quantity);
      });
      cartItems.items.forEach(item => {
        if (Object.keys(itemsToRemove).includes(String(item.id))) {
          const newQty = item.quantity - (itemsToRemove[String(item.id)] || 0);
          updates[item.key] = Math.max(0, newQty);
        }
      });
    }

    await this._updateShopifyCart(updates);
    await this.updateCart();

    this._hideLoader();
  }

  async _fetchShopifyCartContents() {
    return new Promise((resolve, reject) => {
      $.getJSON('/cart.js', (data) => {
        resolve(data);
      });
    });
  }

  _generateBoxCartItems() {
    this.cartItems.boxItems.forEach((item, index) => {
      let mealItems = item.boxItems;

      const { handle } = item;
      let regularBoxPrice = 0;
      let discountedBoxPrice = 0;

      const fiveBox = this.boxData['6er-meal-box'];
      const tenBox = this.boxData['12er-meal-box'];
      const fifteenBox = this.boxData['18er-meal-box'];

      if (handle === fiveBox.handle) {
        regularBoxPrice = fiveBox.compare_at_price;
        discountedBoxPrice = fiveBox.price;
      } else if (handle === tenBox.handle) {
        regularBoxPrice = tenBox.compare_at_price;
        discountedBoxPrice = tenBox.price;
      } else if (handle === fifteenBox.handle) {
        regularBoxPrice = fifteenBox.compare_at_price;
        discountedBoxPrice = fifteenBox.price;
      } else if (item.cartPrice !== undefined) {
        // Fallback fuer non-standard Box-Handles: Preis aus Shopify Cart
        regularBoxPrice = item.cartCompareAtPrice || item.cartPrice;
        discountedBoxPrice = item.cartPrice;
      }

      const hasDiscount = regularBoxPrice && discountedBoxPrice !== regularBoxPrice;

      const formattedDiscountPrice = (discountedBoxPrice * item.quantity / 100).toFixed(2);
      const formattedRegularPrice = (regularBoxPrice * item.quantity / 100).toFixed(2);

      const mealItemString = Object.values(mealItems).map(mealItem => `${mealItem.mealId}:${mealItem.quantity * item.quantity}`);

      const listItem = `
        <div class="custom-drawer__box-list-item">
          <div class="custom-drawer__box-item-header">
            <div class="custom-drawer__box-item-image">
              <img src="${item.image}" />
            </div>
  
            <div class="custom-drawer__box-item-header-content">
              <h1>${item.quantity} x ${item.title}</h1>
  
              <div class="custom-drawer__box-price">
                ${hasDiscount ? `<b class="custom-drawer__box-discounted-price">${formattedDiscountPrice}€</b>` : ''}
                <b class="custom-drawer__box-regular-price ${hasDiscount ? '' : 'active'}">${formattedRegularPrice}€</b>
              </div>
  
              <p class="custom-drawer__remove-box-action" data-index="${index}" data-key="${item.key}" data-box-handle="${item.handle}" data-box-instance-id="${item.boxInstanceId || ''}" data-items="${mealItemString}" data-quantity="${item.quantity}">Entfernen</p>
            </div>
          </div>
          
          <div class="custom-drawer__box-item-ingredients">
            <h2>Inhalt</h2>
  
            <ul>
              ${Object.values(mealItems).map(mealItem => `
                <li class="custom-drawer__ingredient">
                  <div class="custom-drawer__ingredient-content">
                    <p><span>${mealItem.quantity}X</span> ${mealItem.title}</p>
                  </div>
                </li>
              `).join('')}
            </ul>
          </div>
        </div>
      `;

      this.buildABoxListEl.append(listItem);

      const removeBoxActionElements = document.querySelectorAll(`.custom-drawer__remove-box-action[data-key="${item.key}"][data-index="${index}"]`);

      for (let i = 0; i < removeBoxActionElements.length; i++) {
        const removeBoxActionEl = removeBoxActionElements[i];

        removeBoxActionEl.addEventListener('click', (e) => {
          const boxData = e.target.dataset;

          this._removeBoxItem(boxData);
        });
      }
    });
  }

  _generateClearCartButton() {
    // "Warenkorb leeren" Button nur anzeigen wenn Items vorhanden
    $('.custom-drawer__clear-cart').remove(); // Alten Button entfernen

    if (this.cartData.items && this.cartData.items.length > 0) {
      const clearButton = `
        <div class="custom-drawer__clear-cart" style="text-align: center; padding: 10px 0;">
          <p class="custom-drawer__clear-cart-action" style="cursor: pointer; color: #999; font-size: 12px; text-decoration: underline;">Warenkorb leeren</p>
        </div>
      `;

      this.buildABoxListEl.after(clearButton);

      const that = this;
      $('.custom-drawer__clear-cart-action').click(function () {
        if (confirm('Möchtest du deinen gesamten Warenkorb leeren?')) {
          that.clearEntireCart();
        }
      });
    }
  }

  async clearEntireCart() {
    this._showLoader();

    try {
      trackCartEvent('cart_cleared_manually', {
        total_items: this.cartData?.items?.length || 0,
        total_price: this.cartData?.total_price || 0
      });

      // Shopify Cart komplett leeren
      await new Promise((resolve, reject) => {
        $.ajax({
          type: 'POST',
          url: '/cart/clear.js',
          dataType: 'json',
          success: resolve,
          error: reject
        });
      });

      // Alle localStorage-Daten aufraeumen
      localStorage.removeItem('boxItemsInCart');
      localStorage.removeItem('boxMealMap');
      localStorage.removeItem('boxCartLock');
      ['6er', '12er', '18er'].forEach(size => {
        localStorage.removeItem(`${size}-meal-box-meals`);
      });

      await this.updateCart();
    } catch (error) {
      console.error('Error clearing cart:', error);
      alert('Fehler beim Leeren des Warenkorbs. Bitte Seite neu laden.');
    }

    this._hideLoader();
  }

  _updateShippingPrice(total_price) {
    //if ((total_price / 100) < 50) {
    if ((total_price / 100) < parseInt(window.shippingRate)) {
      this.shippingPriceEl.text('4.99€');
    } else {
      this.shippingPriceEl.text('Kostenlos');
    }
  }

  _emptyCart() {
    this.productsContainerEl.empty();
  }

  _updateItemCount() {
    this.cartItemCountEl.text(count);
  }

  _updateTotalPrice(price) {
    const formattedPrice = (price / 100).toFixed(2);
    this.totalPriceEl.text(`${formattedPrice}€`);
  }

  async _updateShopifyCart(updates) {
    document.querySelector('.custom-drawer__checkout-button').disabled = true;
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { updates },
        dataType: 'json',
        success: async (data) => {
          resolve(data);
        },
        error: (data) => {
          reject(data);
        }
      });
    })
    .finally(() => {
      setTimeout(() => {
        document.querySelector('.custom-drawer__checkout-button').disabled = false;
      }, 2000);
    });
  }

  async _fetchBoxData() {
    try {
      const [fiveBox, tenBox, fifteenBox] = await Promise.all([this._fetchFiveBoxData(), this._fetchTenBoxData(), this._fetchFiftinBoxData()]);

      this.boxData[fiveBox.handle] = fiveBox;
      this.boxData[tenBox.handle] = tenBox;
      this.boxData[fifteenBox.handle] = fifteenBox;

      this.hasLoadedBoxData = true;
    } catch (error) {
      console.log('error: ', error);
    }
  }

  _fetchFiveBoxData() {
    const that = this;

    return new Promise(function (resolve, reject) {
      $.getJSON(that.baseUrl + 'products/6er-meal-box.js', function (fiveBox) {
        resolve(fiveBox);
      });
    });
  }

  _fetchTenBoxData() {
    const that = this;

    return new Promise(function (resolve, reject) {
      $.getJSON(that.baseUrl + 'products/12er-meal-box.js', function (tenBox) {
        resolve(tenBox);
      });
    });
  }

  _fetchFiftinBoxData() {
    const that = this;

    return new Promise(function (resolve, reject) {
      $.getJSON(that.baseUrl + 'products/18er-meal-box.js', function (fifteenBox) {
        resolve(fifteenBox);
      });
    });
  }
}

// const newDebounce = (func, wait) => {
//   let timeout;
//   return function (...args) {
//     clearTimeout(timeout);
//     timeout = setTimeout(() => func.apply(this, args), wait);
//   };
// }
// if (!customElements.get('cart-note')) {
//   customElements.define('cart-note', class CartNote extends HTMLElement {
//     constructor() {
//       super();

//       this.addEventListener('change', newDebounce((event) => {
//         const body = JSON.stringify({ note: event.target.value });
//         fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
//       }, 300))
//     }
//   });
// };
const newDebounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();
      this.textarea = this.querySelector('textarea');
      
      // Initialize the textarea with proper value
      if (this.textarea.value === 'undefined' || this.textarea.value === 'null') {
        this.textarea.value = '';
      }
      
      this.setupEventListeners();
    }

    setupEventListeners() {
      this.addEventListener('change', newDebounce((event) => {
        const noteValue = event.target.value.trim();
        
        // Don't send 'undefined' or 'null' as strings
        const noteToSend = noteValue === 'undefined' || noteValue === 'null' ? '' : noteValue;
        
        // Update cart note via fetch
        const body = JSON.stringify({ note: noteToSend });
        fetch(`${routes.cart_update_url}`, { 
          ...fetchConfig(), 
          ...{ body } 
        })
        .then(response => response.json())
        .then(data => {
          // Update textarea value after successful update
          if (data) {
            // Ensure we don't display 'undefined' or 'null' in the textarea
            this.textarea.value = noteToSend;
          }
        })
        .catch(error => {
          console.error('Error updating cart note:', error);
        });
      }, 300));
    }
  });
}